import React, { useContext, useEffect } from "react";
import AdminLayout from "../../components/layout/AdminLayout";

import * as FaIcons from "react-icons/fa";

import { Helmet } from "react-helmet-async";

import OrientationTable from "../../components/registrationAdmin/OrientationTable";
import LoadingSpinner from "../../components/utilities/LoadingSpinner";
import llacFav from "../../img/LLAC-favicon.ico";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

const RegistrationFormListPage = () => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { getScheduledOrientations, scheduledOrientations, loading } =
    adminRegistrationContext;

  useEffect(() => {
    getScheduledOrientations();
    return () => {};
  }, []);
  return (
    <AdminLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Registration Dashboard</title>
        <link rel="icon" type="image/x-icon" href={llacFav} />
      </Helmet>
      <section id="interest-form-list-page">
        <div className="container">
          <h2 className="text-center top-title">Scheduled Orientations</h2>
          {scheduledOrientations.length > 0 ? (
            <OrientationTable
              items={scheduledOrientations}
            />
          ) : !loading ? (
            <div className="interest-complete">
              <FaIcons.FaCheckSquare className="done-icon" />
              <p>No Scheduled Orientations to process</p>
              <p>Good Job!</p>
            </div>
          ) : (
            <LoadingSpinner />
          )}
        </div>
      </section>
    </AdminLayout>
  );
};

export default RegistrationFormListPage;
